import { Directive, OnDestroy } from '@angular/core';
import { combineLatest, Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { PrivaSegmentService } from '@priva/analytics/segment';

import { ApplicationToggles } from 'app/app-features.enum';
import { CurrentUserFacade } from 'app/current-user/state/current-user.facade';

import { FeatureTogglesService } from '../feature-toggles/feature-toggle-service';

@Directive({ selector: '[analyticsLogUserTraits]' })
export class LogUserTraitsDirective implements OnDestroy {
    private readonly unsubscribe$ = new Subject<void>();
    betaFeatureEnabled$: Observable<boolean>;
    hasUserManageReportsFeature$: Observable<boolean> = this.currentUserFacade.hasUserManageReportsFeature$;

    constructor(
        private readonly currentUserFacade: CurrentUserFacade,
        private readonly featureTogglesService: FeatureTogglesService,
        private readonly analytics: PrivaSegmentService,
    ) {
        this.betaFeatureEnabled$ = this.featureTogglesService.hasToggleEnabled$(
            ApplicationToggles.betaFeature,
        );
        combineLatest([this.betaFeatureEnabled$, this.hasUserManageReportsFeature$])
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(([betaFeatureEnabled, hasUserManageReportsFeature]: [boolean, boolean]) => {
                this.analytics.identify({
                    has_analytics_manage_access: hasUserManageReportsFeature,
                    has_analytics_beta_access: betaFeatureEnabled,
                });
            });
    }

    ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }
}
